import { timePickerDefaultProps as e } from "./index581.js";
import { buildProps as r, definePropType as t } from "./index601.js";
const i = r({
  ...e,
  /**
   * @description type of the picker
   */
  type: {
    type: t(String),
    default: "date"
  }
});
export {
  i as datePickerProps
};
